import * as types from "./types";

const mutations = {
    [types.LOADING_TAX](state, value) {
        state.loading = value;
    },
    [types.GET_TAX_LIST](state, taxs) {
        state.taxs = taxs;
        console.log("Testing state" + state.taxs);
    },
    [types.REMOVE_TAX](state, id) {        
        state.taxs = state.taxs.filter((x) => x.id !== id);        
    },
    [types.ADD_TAX](state, tax) {        
        state.taxs.unshift(tax);
    },
    [types.UPDATE_TAX](state, tax) {        
        const taxIndex = state.taxs.findIndex((x) => x.id === tax.id);
        state.taxs[taxIndex] = tax;        
    },
    [types.GET_TAXBYID](state, taxId) {
        state.taxId = taxId;
    }
};

export default mutations;